import {
  getGradingCommentTemplatesField,
  getLearningCourseField,
} from "./modules/utils";

const UBDCurriculumProgramPolicy = {
  UBDCurriculumProgram: {
    fields: {
      gradingCommentTemplates: getGradingCommentTemplatesField(),
      learningCourse: getLearningCourseField(),
    },
  },
};

export default UBDCurriculumProgramPolicy;
